<!-- @format -->

<project-index-tag>
  <project-status-tag></project-status-tag>
  <div class="container_contents">

    <div class="container_breadcrumb">
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><h1 class="heading-01 heading_projects">稼働プロジェクト</h1></li>
      </ul>
    </div><!--/.container_breadcrumb-->

    <div class="contents">
      <section class="contents_area">
        <p class="text margin-spacing-4_bottom">現在、稼働中のプロジェクトの一覧です。<br>完了したプロジェクトは「<a href="/project/history">受注履歴・請求関連</a>」からご確認下さい。</p>
        <div class="container_sort margin-spacing-2_bottom">
          
          <div class="box_sort">
            <div class="sort-menu margin-spacing-2_right">
              <select class="sort-list" name="state" onchange={(e)=>changeState(e)}>
                <option value="">全て</option>
                <option value="100">指名オファー</option>
                <option value="200-300">契約確定待ち</option>
                <option value="400">制作物提出待ち</option>
              </select>
            </div><!--/.sort-menu-->
            <div class="sort-menu">
              <select class="sort-list" name="order" onchange={(e)=>changeOrder(e)}>
                <option value="limit_asc">提出期限が近い順</option>
                <option value="limit_desc">提出期限が遠い順</option>
                <option value="limit_in5d">提出期限残り5日以内</option>
                <option value="limit_in10d">提出期限残り10日以内</option>
              </select>
            </div><!--/.sort-menu-->
          </div><!--/.box_sort-->

          <p class="search_number">全{ state.total }件中　1〜{ state.projects.length }件</p>

        </div><!--/.container_sort-->

        <template if={ state.projects.length > 0}>
          <project-item-tag project={project} idx={i} each={(project,i) in state.projects}></project-item-tag>
          <edilent-pagination-tag pager="{state.pager}" onpager="{(e,page)=>select(e,page)}" if={state.pager.last > 1}></edilent-pagination-tag>
        </template>
        <template if={ state.projects.length === 0}>
          <div class="empty margin-spacing-3_top">
            <p class="empty-message">現在稼働中のプロジェクトはありません。</p>
          </div>
        </template>
      </section><!--/.contents_area-->
    </div>

  </div>
<script>
  import di from "dependeny-injection";
  import projectItem from "@tags/pages/project/project-item.riot";

  export default {
    components: {
      'project-item-tag': projectItem
    },
    state: {
      limit: 10,
      state: '',
      order: 1,
      projects: [],
      page: 1,
      total:0,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0},
    },
    select(e, page) {
      e.preventDefault();
      this.state.page = page;
      this.fetchProjects();
    },
    changeOrder(e) {
      this.state.order = e.target.value;
      this.state.page = 1;
      this.fetchProjects();
    },
    changeState(e) {
      this.state.state = e.target.value;
      this.state.page = 1;
      this.fetchProjects();
    },
    onProjectsFetched(data){
      this.update({
        projects    : data.items,
        pager       : data,
        page        : data.page,
        total       : data.total
      });
    },
    fetchProjects(){
      const params = {
        page: this.state.page,
        state: this.state.state,
        order: this.state.order,
        limit: this.state.limit
      };
      this.api.request('index', 'fetch-projects', params)
        .then(data=>this.onProjectsFetched(data));
    },
    onBeforeMount(props, state){
      this.api = di.createApi('project');
      this.fetchProjects();
    }
  }
</script>
</project-index-tag>
